import axios from "axios";

export const getContentsByIds = async (
  contentsIds: string,
  duplicate: boolean
) => {
  const response = await axios.get(
    `${process.env.REACT_APP_SERVER_URL}api/public/contents?ids=${contentsIds}&duplicate=${duplicate}`
  );
  console.log("getIDs");
  return response.data;
};
